import { SVGProps } from "react";

export default function ColorsSquare(props: SVGProps<SVGSVGElement>) {
  const {
    height = 20,
    width = 20,
    fill = "none",
    stroke = "#292D32",
    ...rest
  } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11 12.001C11 12.8844 10.6167 13.6844 10 14.2344C9.46667 14.7177 8.76665 15.001 7.99998 15.001C6.34165 15.001 5 13.6594 5 12.001C5 10.6177 5.94169 9.45104 7.20835 9.10938C7.55002 9.97604 8.29166 10.651 9.20832 10.901C9.45832 10.9677 9.725 11.0094 10 11.0094C10.275 11.0094 10.5417 10.976 10.7917 10.901C10.925 11.2344 11 11.6094 11 12.001Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 8C13 8.39167 12.925 8.76667 12.7916 9.10833C12.45 9.975 11.7083 10.65 10.7917 10.9C10.5417 10.9667 10.275 11.0083 9.99998 11.0083C9.72498 11.0083 9.4583 10.975 9.2083 10.9C8.29164 10.65 7.55 9.98333 7.20833 9.10833C7.075 8.76667 7 8.39167 7 8C7 6.34167 8.34165 5 9.99998 5C11.6583 5 13 6.34167 13 8Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 12.0016C15 13.6599 13.6584 15.0016 12 15.0016C11.2334 15.0016 10.5333 14.7099 10 14.2349C10.6167 13.6932 11 12.8932 11 12.0016C11 11.6099 10.925 11.2349 10.7917 10.8932C11.7083 10.6432 12.45 9.97656 12.7916 9.10156C14.0583 9.45156 15 10.6182 15 12.0016Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.4974 18.3307H12.4974C16.6641 18.3307 18.3307 16.6641 18.3307 12.4974V7.4974C18.3307 3.33073 16.6641 1.66406 12.4974 1.66406H7.4974C3.33073 1.66406 1.66406 3.33073 1.66406 7.4974V12.4974C1.66406 16.6641 3.33073 18.3307 7.4974 18.3307Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
